
import FiltroPeriodo from "./FiltroPeriodo.vue";

export default {
  name: "Vendas",
  components: { FiltroPeriodo },
  props: {
    // valor total das vendas (ex.: 1237.98)
    valorVendas: { type: [Number, String], default: 0 },

    // período atual (ex.: { inicio: '2025-10-01', fim: '2025-10-15' })
    periodo: { type: Object, default: null },

    // controla exibição do skeleton
    loading: { type: Boolean, default: false },

    // evita emitir evento inicial (quando a tela carrega)
    ignoreInitialApply: { type: Boolean, default: true },
  },
  computed: {
    vendasNumber() {
      const n = Number(this.valorVendas);
      return Number.isFinite(n) ? n : 0;
    },
  },
  methods: {
    // repassa o evento para o pai
    onApplyPeriodo({ inicio, fim }) {
      this.$emit("change-periodo", { inicio, fim });
    },

    // formata em R$ com padrão pt-BR
    formatCurrency(v) {
      try {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(v ?? 0);
      } catch {
        const num = Number(v ?? 0)
          .toFixed(2)
          .replace(".", ",");
        return `R$ ${num}`;
      }
    },
  },
};
